'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ticker = exports.headerHandlerTransform = exports.headerHandler = undefined;

var _setup = require('./setup.js');

var _productSingle = require('./product-single.js');

var headerTop = _setup.s.$header.css('top');
var scrollDirection = 'down';
var scrollstarted = false;

var scrollDirectionEvents = function scrollDirectionEvents() {
	// if going up && not already going up
	// $s.$doc.trigger('nx.scroll.up')
	// else if going down && not already going down
	// $s.doc.trigger('nx.scroll.down')
};

var scrollUpdate = function scrollUpdate() {
	_setup._s.scrollCurrent = window.pageYOffset;
	_setup._s.scrollDiff = _setup._s.scrollPrev - _setup._s.scrollCurrent;

	headerTop = parseInt(_setup.s.$header.css('top')) + _setup._s.scrollDiff;
};

var resizeUpdate = function resizeUpdate() {
	_setup._s.winHeight = _setup.s.$window.height();
	_setup._s.headerHeight = _setup.s.$header.outerHeight();
};

//add class to elements as they appear on screen
var inviewElsDone = [];
var inviewHandler = function inviewHandler() {
	if (inviewElsDone.length >= _setup.s.$inviewElements.length) return;

	_setup.s.$inviewElements.each(function (i) {
		if (inviewElsDone.length === _setup.s.$inviewElements.length) return;
		var $t = $(this);
		if ($t.inView(true) && !$t.hasClass('is-in-view')) {
			$t.addClass('is-in-view');
			inviewElsDone.push(i);
		}
	});
};

var headerHandler = exports.headerHandler = function headerHandler() {
	if (_setup._s.menuOverlayShowing || _setup._s.searchOverlayShowing) return;

	if (_setup._s.scrollCurrent <= 0) {
		_setup.s.$header.css('top', 0).addClass('is-at-top');
	} else if (_setup._s.scrollDiff > 0) {

		_setup.s.$header.css('top', headerTop > 0 ? 0 : headerTop);
	} else if (_setup._s.scrollDiff < 0) {

		_setup.s.$header.css('top', Math.abs(headerTop) > _setup._s.headerHeight ? -_setup._s.headerHeight : headerTop);
	}

	if (_setup._s.scrollCurrent > _setup._s.headerHeight) {
		_setup.s.$header.removeClass('is-at-top');
	} else {}

	_setup._s.scrollPrev = _setup._s.scrollCurrent;
};

// More performant headroom behavior
var headerIsShowing = false;
//let shouldDoScrollup = true;

var headerHandlerTransform = exports.headerHandlerTransform = function headerHandlerTransform() {
	var pastHeader = _setup._s.scrollCurrent >= _setup._s.headerHeight;

	if (_setup._s.scrollCurrent <= 1) {
		_setup.s.$header.addClass('is-at-top');
	} else if (pastHeader) {}
	//s.$header.removeClass('is-at-top');


	//scrolling outside header height space
	if (pastHeader) {
		_setup.s.$header.removeClass('is-at-top');
		//if scrolling within header height space (top 80-100px or so)
	} else {
		return false;
	}

	//scrolling back up
	if (_setup._s.scrollDiff > 8 && !headerIsShowing) {
		_setup.s.$header.addClass('is-scrolling-up');
		headerIsShowing = true;
		//scrolling down
	} else if (_setup._s.scrollDiff < -1 && headerIsShowing) {
		_setup.s.$header.removeClass('is-scrolling-up');
		headerIsShowing = false;
	}

	_setup._s.scrollPrev = _setup._s.scrollCurrent;
};

var ticker = exports.ticker = function ticker() {
	if (_setup._s.didScroll) {

		scrollUpdate();

		headerHandler();
		//headerHandlerTransform();

		inviewHandler();
		(0, _productSingle.subnavScrollHandler)();

		if (!scrollstarted) {
			_setup.s.$doc.trigger('nx.scroll.start');
			scrollstarted = true;
		}

		_setup._s.didScroll = false;
	}
	requestAnimationFrame(ticker);
};

_setup.s.$window.on({
	scroll: function scroll() {
		return _setup._s.didScroll = true;
	},
	resize: function resize() {
		return resizeUpdate();
	}
});


//////////////////
// WEBPACK FOOTER
// ./_js/ticker.js
// module id = 3
// module chunks = 0